var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.88141 1.75C10.6637 1.75 11.4162 2.05917 11.9697 2.61392C12.5239 3.1675 12.8337 3.91417 12.8337 4.69583V9.30417C12.8337 10.9317 11.5095 12.25 9.88141 12.25H4.11866C2.49058 12.25 1.16699 10.9317 1.16699 9.30417V4.69583C1.16699 3.06833 2.48474 1.75 4.11866 1.75H9.88141ZM10.8095 5.565L10.8562 5.51833C10.9956 5.34917 10.9956 5.10417 10.8497 4.935C10.7687 4.84808 10.6572 4.795 10.5412 4.78333C10.4187 4.77692 10.302 4.81833 10.2139 4.9L7.58366 7C7.24533 7.28058 6.76058 7.28058 6.41699 7L3.79199 4.9C3.61058 4.76583 3.35974 4.78333 3.20866 4.94083C3.05116 5.09833 3.03366 5.34917 3.16724 5.52417L3.24366 5.6L5.89783 7.67083C6.22449 7.9275 6.62058 8.0675 7.03533 8.0675C7.44891 8.0675 7.85199 7.9275 8.17808 7.67083L10.8095 5.565Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.d8f800aa0d7a7b94a4030d0ae1d66c92.svg";
export { ForwardRef as ReactComponent };